import React from "react"
import { useLocation } from "react-router-dom"

import TicketsTable from "../Tickets"
import PromosTable from "../Promos"
import OrdersTable from "../Orders"
import FlightsTable from '../Flights'
import AirportsTable from '../Airports'

function Dashboard() {
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const activeTab = queryParams.get("tab") || "tickets"

    return (
        <div className="container-fluid p-3">
            {/* Tab Content */}
            <div className="tab-content mt-3">
                <div className={`tab-pane fade ${activeTab === "tickets" ? "show active" : ""}`}>
                    <TicketsTable />
                </div>
                <div className={`tab-pane fade ${activeTab === "bookings" ? "show active" : ""}`}>
                    <OrdersTable />
                </div>
                <div className={`tab-pane fade ${activeTab === "promos" ? "show active" : ""}`}>
                    <PromosTable />
                </div>
                <div className={`tab-pane fade ${activeTab === "flights" ? "show active" : ""}`}>
                    <FlightsTable />
                </div>
                <div className={`tab-pane fade ${activeTab === "airports" ? "show active" : ""}`}>
                    <AirportsTable />
                </div>
            </div>
        </div>
    )
}

export default Dashboard
